import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useConsultantNetwork = (id) => useQuery({ queryKey: [`${id}-network`], queryFn: async () => {
    const callback = await API.get(`/consultants/${id}/network`)
    return callback?.data
}})

export default useConsultantNetwork